const Group = {
    FERTIG: "FERTIG",
    UNTERWEGS: "UNTERWEGS",
    STOPPT: "STOPPT"
};
const Workstatus = {
    UNTERWEGS: "UNTERWEGS",
    STORZEIT: "STORZEIT",
    STEHT: "STEHT",
    PAUSE: "PAUSE"
};
const TripStatus = {
    DELIVERED: "DELIVERED",
    ONGOING: "ONGOING",
    QUEUED: "QUEUED"
};
export { Group, Workstatus, TripStatus };
